import { connect } from 'react-redux';
import { selectActiveVenueId, selectSchedulesStartDate } from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';

import {
  selectSchedulesBoardFiltersQueries,
  selectSchedulesBoardNextDate,
  selectSchedulesInstances,
  selectSchedulesInstancesIsLoading,
  selectSelectedScheduleInstanceId,
} from '../../Schedules.selectors';
import { fetchSchedulesInstances } from '../../Schedules.saga';
import SchedulesList from './SchedulesList';

const mapStateToProps = state => {
  return {
    filterQueries: selectSchedulesBoardFiltersQueries(state),
    isDesktop: selectIsDesktop(state),
    isLoading: selectSchedulesInstancesIsLoading(state),
    nextDate: selectSchedulesBoardNextDate(state),
    schedulesInstances: selectSchedulesInstances(state),
    selectedScheduleId: selectSelectedScheduleInstanceId(state),
    startDate: selectSchedulesStartDate(state),
    venueId: selectActiveVenueId(state),
  };
};

const mapDispatchToProps = {
  fetchSchedulesInstances,
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulesList);
